import { commonSlice } from "./reducers";
export const {
  toogleBackdrop,
  setVideoUploadData,
  setIsVideoUploading,
  updateFilters,
} = commonSlice.actions;
export default commonSlice.actions;
